import React, { useContext, useEffect, useState } from 'react';
import { formatDttm } from '../../../Util/timezone';
import { useHistory } from 'react-router-dom';
import { AdminCompanyMarginContext } from '../../../Context/AdminCompanyMarginContextProvider';
import { AdminLoadedMarginContext } from '../../../Context/AdminLoadedMarginContextProvider';
import { AdminMaterialClassMarginContext } from '../../../Context/AdminMaterialClassMarginContextProvider';
import { AdminContext } from '../../../Context/AdminContextProvider';

import { InfoButtonContextProvider } from '../../Shared/InfoButton';

import { TaxUpdate } from '../ManageTax/TaxUpdate';
import { SalesTax } from '../ManageTax/SalesTax';
import UnitConversions from './UnitConversions';
import CalculationSummary from '../CustomCalculations/CalculationSummary';
import CostAdjustmentRules from './CostAdjustmentRules';
import FreightRates from './FreightRates';

// Styles
import '../../styles/MND.css';

// MUI
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
// import InfoIcon from "@material-ui/icons/Info";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  Button,
  NativeSelect,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  FormControlLabel,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  Switch,
  CircularProgress,
  InputAdornment,
  Tooltip,
} from '@material-ui/core';
import {
  updateCompanyMargin,
  updateLoadedMargin,
  upsertRoleToMargin,
  getRetailRoundUp,
  setRetailRoundUp,
  getUsePromoPrice,
  setUsePromoPrice,
} from '../../../Actions';
import { AlertContext } from '../../../Context/AlertContextProvider';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

const CompanyMarginUpdate = () => {
  const { roles } = useContext(AdminContext);
  const { margin, setUpdate } = useContext(AdminCompanyMarginContext);
  const { loadedMargin, setUpdate: setLoadedUpdated } = useContext(
    AdminLoadedMarginContext
  );
  const { handleAlertOpen, setMessageType, setMessage } =
    useContext(AlertContext);
  const {
    setId,
    materialClassMargins,
    setUpdate: setMaterialClassMargins,
  } = useContext(AdminMaterialClassMarginContext);

  const [marginRate, setCompanyMargin] = useState(0);
  const [loadedMarginRate, setLoadedMargin] = useState(0);
  const [materialMarginRate, setMaterialMarginRate] = useState({});
  const [loadedMarginByClass, setLoadedMarginByClass] = useState({});
  const [loadedMarkupByClass, setLoadedMarkupByClass] = useState({});
  const [productDisclaimer, setProductDisclaimer] = useState({});
  const [addToCost, setAddToCost] = useState({});
  const [addToPrice, setAddToPrice] = useState({});
  // Snapshot of the values as loaded, keyed by material_class, so we can tell
  // which rows changed and save only those in one batch.
  const [originalValues, setOriginalValues] = useState({});
  const [savingAll, setSavingAll] = useState(false);
  const [roleId, setRoleId] = useState();
  const [RoundUp, setRoundUp] = useState('0');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [roleName, SetRoleName] = useState();
  const history = useHistory();
  const [switchState, setSwitchState] = useState(false);

  //const [loadedMarginRate, setCompanyMargin] = useState(0);
  useEffect(() => {
    getUsePromoPrice().then((result) => {
      if (parseInt(result.data.data[0].app_value_text) === 1) {
        setSwitchState(true);
      } else {
        setSwitchState(false);
      }
    });

    getRetailRoundUp().then((result) => {
      setRoundUp(result.data.data[0].round_up);
    });

    if (margin.length) {
      setCompanyMargin(margin[0].company_margin);
    }
    if (loadedMargin.length) {
      setLoadedMargin(loadedMargin[0].loaded_margin);
    }
    if (materialClassMargins.length) {
      let tempMarClassMargins = {};
      let tempLoadedMargins = {};
      let tempLoadedMarkups = {};
      let tempAddToCost = {};
      let tempAddToPrice = {};
      let tempProductDisclaimer = {};
      let tempOriginals = {};
      materialClassMargins.forEach((element) => {
        const mc = element['material_class'];
        tempMarClassMargins[mc] = element['margin'];
        tempLoadedMargins[mc] = element['loaded_margin'];
        tempLoadedMarkups[mc] = element['loaded_markup'];
        tempAddToCost[mc] = element['add_to_cost'];
        tempAddToPrice[mc] = element['add_to_price'];
        tempProductDisclaimer[mc] =
          element['disclaimer'] == null ? '' : element['disclaimer'];
        tempOriginals[mc] = {
          margin: element['margin'],
          loaded_margin: element['loaded_margin'],
          loaded_markup: element['loaded_markup'],
          add_to_cost: element['add_to_cost'],
          add_to_price: element['add_to_price'],
          disclaimer: tempProductDisclaimer[mc],
        };
      });
      setMaterialMarginRate(tempMarClassMargins);
      setLoadedMarginByClass(tempLoadedMargins);
      setLoadedMarkupByClass(tempLoadedMarkups);
      setAddToCost(tempAddToCost);
      setAddToPrice(tempAddToPrice);
      setProductDisclaimer(tempProductDisclaimer);
      setOriginalValues(tempOriginals);
    }
  }, [margin, loadedMargin, materialClassMargins]);

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    if (
      getDirtyRows(materialClassMargins).length &&
      !window.confirm('You have unsaved changes. Close without saving?')
    ) {
      return;
    }
    setDialogOpen(false);
    history.push('/admin');
  };

  const handleRetailRoundUp = (e) => {
    setRoundUp(e.target.value);
  };

  const handleSetRetailRoundUp = () => {
    setRetailRoundUp(RoundUp)
      .then(() => {
        setMessage('Successfully updated retail round up');
        setMessageType('success');
        handleAlertOpen();
      })
      .catch(() => {
        setMessage('Error updating retail round up');
        setMessageType('error');
        handleAlertOpen();
      });
  };

  const handleRoleSelect = (e) => {
    setRoleId(JSON.parse(e.target.value).role_id);
    SetRoleName(JSON.parse(e.target.value).role_name);
    setId(JSON.parse(e.target.value).role_id);
    handleDialogOpen();
  };

  const handleUpdateCompanyMargin = (e) => {
    setCompanyMargin(e.target.value);
  };

  const handleCompanyMarginUpdate = () => {
    updateCompanyMargin(marginRate)
      .then(() => {
        setMessage('Successfully update company margin');
        setMessageType('success');
        handleAlertOpen();
        setUpdate(true);
      })
      .catch(() => {
        setMessage('Error updating company margin');
        setMessageType('error');
        handleAlertOpen();
      });
  };

  const handleCompanyMarginSubmit = (e) => {
    e.preventDefault();
    handleCompanyMarginUpdate();
  };

  //////////////////////////////////////////

  const handleUpdateLoadedMargin = (e) => {
    setLoadedMargin(e.target.value);
  };

  const handleLoadedMarginUpdate = () => {
    updateLoadedMargin(loadedMarginRate)
      .then(() => {
        setMessage('Successfully update loaded margin');
        setMessageType('success');
        handleAlertOpen();
        setLoadedUpdated(true);
      })
      .catch(() => {
        setMessage('Error updating loaded margin');
        setMessageType('error');
        handleAlertOpen();
      });
  };

  const handleLoadedMarginSubmit = (e) => {
    e.preventDefault();
    handleLoadedMarginUpdate();
  };

  //////////////////////////////////////////

  const handleUpdateMaterialMargin = (e, materialClass) => {
    setMaterialMarginRate({
      ...materialMarginRate,
      [materialClass]: e.target.value,
    });
  };

  const handleUpdateLoadedMarginByClass = (e, materialClass) => {
    setLoadedMarginByClass({
      ...loadedMarginByClass,
      [materialClass]: e.target.value,
    });
  };

  const handleUpdateLoadedMarkupByClass = (e, materialClass) => {
    setLoadedMarkupByClass({
      ...loadedMarkupByClass,
      [materialClass]: e.target.value,
    });
  };

  const handleUpdateProductDisclaimer = (e, materialClass) => {
    setProductDisclaimer({
      ...productDisclaimer,
      [materialClass]: e.target.value,
    });
  };

  const handleUpdateAddToCost = (e, materialClass) => {
    setAddToCost({
      ...addToCost,
      [materialClass]: e.target.value,
    });
  };

  const handleUpdateAddToPrice = (e, materialClass) => {
    setAddToPrice({
      ...addToPrice,
      [materialClass]: e.target.value,
    });
  };

  // Treat null / undefined / '' as the same empty value, and compare by string
  // so 5 and "5" match — avoids flagging a row dirty just from input coercion.
  const normVal = (v) => (v === null || v === undefined ? '' : String(v).trim());

  const isRowDirty = (materialClass) => {
    const o = originalValues[materialClass] || {};
    return (
      normVal(materialMarginRate[materialClass]) !== normVal(o.margin) ||
      normVal(loadedMarginByClass[materialClass]) !== normVal(o.loaded_margin) ||
      normVal(loadedMarkupByClass[materialClass]) !== normVal(o.loaded_markup) ||
      normVal(addToCost[materialClass]) !== normVal(o.add_to_cost) ||
      normVal(addToPrice[materialClass]) !== normVal(o.add_to_price) ||
      normVal(productDisclaimer[materialClass]) !== normVal(o.disclaimer)
    );
  };

  const getDirtyRows = (rows) =>
    (rows || []).filter((r) => isRowDirty(r.material_class));

  // Save every changed row at once instead of one Update click per row.
  const handleSaveAll = async (rows) => {
    const dirty = getDirtyRows(rows);
    if (!dirty.length) return;
    setSavingAll(true);
    try {
      await Promise.all(
        dirty.map((row) =>
          upsertRoleToMargin(
            roleId,
            row.material_class_cd,
            materialMarginRate[row.material_class],
            addToCost[row.material_class],
            addToPrice[row.material_class],
            productDisclaimer[row.material_class],
            loadedMarginByClass[row.material_class],
            loadedMarkupByClass[row.material_class]
          )
        )
      );
      setMessage(
        `Saved ${dirty.length} material class margin${dirty.length > 1 ? 's' : ''}`
      );
      setMessageType('success');
      handleAlertOpen();
      setLoadedUpdated(true);
      setMaterialClassMargins(true); // reloads context → re-snapshots originals
    } catch (err) {
      setMessage('Error saving one or more material class margins');
      setMessageType('error');
      handleAlertOpen();
    }
    setSavingAll(false);
  };

  const handlePromoSwitch = (event) => {
    setSwitchState(event.target.checked);
    if (Number(event.target.checked) === 1) {
      setUsePromoPrice('1');
    }
    if (Number(event.target.checked) === 0) {
      setUsePromoPrice('0');
    }
  };

  // const getMarginRateValue = (materialClass) => {
  //   return ;
  // };

  // const handleAddToCostSubmit = (e, materialClass, addToCost) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  // };

  const renderChangeInfo = (data) => {
    if (data.length) {
      const marginData = data[0];
      return [
        `LAST MODIFIED BY: ${marginData.name}`,
        `LAST MODIFIED USER: ${marginData.user_name}`,
        `LAST MODIFIED: ${formatDttm(marginData.last_modified_dttm)}`,
      ];
    }
  };

  const renderUsePromoPrice = () => {
    return (
      <div>
        <div className="mnd__header">
          <Typography className="mnd__header-text" variant="h4">
            Promo Cost
          </Typography>
        </div>
        <Grid container className="MND__disclaimer-bg">
          <Grid container spacing={0} style={{ padding: 20 }}>
            <Grid item xs={12}>
              <Grid container spacing={0} style={{ marginTop: 50 }}>
                <Grid item xs={5}>
                  <Typography variant="button" className="promo-switch">
                    Standard
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Switch
                    checked={switchState}
                    onChange={handlePromoSwitch}
                    color="primary"
                    size="medium"
                  ></Switch>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="button" className="promo-switch">
                    Promo
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 10 }}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
              >
                <Typography variant="h6">Promo Cost</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Use distributor promotional cost in lieu of the standard cost
                  when calculating price.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>
      </div>
    );
  };

  const renderRetailRoundup = () => {
    return (
      <div>
        <div className="mnd__header">
          <Typography className="mnd__header-text" variant="h4">
            Retail Round Up
          </Typography>
        </div>
        <Grid container className="MND__disclaimer-bg">
          <Grid item xs={9} className="MND__disclaimer-grids">
            <FormControl>
              <FormLabel id="demo-controlled-radio-buttons-group">
                Round up to:
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={RoundUp}
                onChange={handleRetailRoundUp}
              >
                <FormControlLabel
                  value=".00"
                  control={<Radio color="default" />}
                  label="None"
                />
                <FormControlLabel
                  value=".05"
                  control={<Radio color="default" />}
                  label={
                    <>
                      $.05
                      <Typography
                        style={{ color: '#FF682C' }}
                        variant="inherit"
                      >
                        {' '}
                        ($2.00, $2.05, $2.10, $2.15...)
                      </Typography>
                    </>
                  }
                />
                <FormControlLabel
                  value=".09"
                  control={<Radio color="default" />}
                  label={
                    <>
                      $.09
                      <Typography
                        style={{ color: '#FF682C' }}
                        variant="inherit"
                      >
                        {' '}
                        ($2.09, $2.19, $2.29, $2.39...)
                      </Typography>
                    </>
                  }
                />
                <FormControlLabel
                  value=".08"
                  control={<Radio color="default" />}
                  label={
                    <>
                      $.08
                      <Typography
                        style={{ color: '#FF682C' }}
                        variant="inherit"
                      >
                        {' '}
                        ($2.08, $2.18, $2.28, $2.38...)
                      </Typography>
                    </>
                  }
                />
                <FormControlLabel
                  value=".19"
                  control={<Radio color="default" />}
                  label={
                    <>
                      $.19
                      <Typography
                        style={{ color: '#FF682C' }}
                        variant="inherit"
                      >
                        {' '}
                        ($2.19, $2.39, $2.59, $2.79...)
                      </Typography>
                    </>
                  }
                />
                <FormControlLabel
                  value=".25"
                  control={<Radio color="default" />}
                  label={
                    <>
                      $.25
                      <Typography
                        style={{ color: '#FF682C' }}
                        variant="inherit"
                      >
                        {' '}
                        ($2.00, $2.25, $2.50, $2.75, $3.00)
                      </Typography>
                    </>
                  }
                />
                <FormControlLabel
                  value=".49"
                  control={<Radio color="default" />}
                  label={
                    <>
                      $.49
                      <Typography
                        style={{ color: '#FF682C' }}
                        variant="inherit"
                      >
                        {' '}
                        ($2.49, $2.99)
                      </Typography>
                    </>
                  }
                />
                <FormControlLabel
                  value=".99"
                  control={<Radio color="default" />}
                  label={
                    <>
                      $.99
                      <Typography
                        style={{ color: '#FF682C' }}
                        variant="inherit"
                      >
                        {' '}
                        ($2.99)
                      </Typography>
                    </>
                  }
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={4} className="MND__disclaimer-grids">
            <Button
              className="admin__tax-update-btn"
              variant="contained"
              onClick={handleSetRetailRoundUp}
            >
              Update
            </Button>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 10 }}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
              >
                <Typography variant="h6">Retail Round Up</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Select the amount you would like the retail price rounded up
                  to.
                  <br />
                  <br />
                  (E.g $.25 rounds the retail price UP to the nearest 25 cents.)
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>
      </div>
    );
  };

  // const renderCompanyMarginDetails = data => {
  //   // return data.length ? <div> Tax Data </div> : <div>Loading...</div>;
  //   if (data.length) {
  //     return (
  //       <div>
  //         {/* <Card>
  //           <CardContent> */}
  //         <form onSubmit={handleCompanyMarginSubmit}>
  //           <TableContainer className="cost-adjustment-paper">
  //           <div className="mnd__header">
  //             <Typography
  //               className="header-text"
  //               variant="h4">
  //               Company Margin
  //             </Typography>
  //             </div>
  //             <Table className="class-margin-details" aria-label="simple table">
  //               <TableHead>
  //                 <TableRow className="mnd__table-row">
  //                   {/* <TableCell><InfoButtonContextProvider buttonLabel="How does this apply?" heading="Company Margin:" messages={["Company wide default margin"]}/></TableCell> */}
  //                 </TableRow>
  //               </TableHead>
  //               <TableBody>
  //                 <TableRow className="mnd__table-row">
  //                   {/* <TableCell alig="center">
  //                     Company Margin (Percentage)</TableCell> */}
  //                     {/* <TableCell
  //                     className="mnd__table-cell"
  //                     align="center"
  //                     width="10px"
  //                   >
  //                     <InfoButtonContextProvider
  //                       buttonLabel="Modification Details"
  //                       heading="Modification Details:"
  //                       messages={renderChangeInfo(margin)}
  //                     />
  //                   </TableCell> */}
  //                   <TableCell
  //                     className="mnd__table-cell"
  //                     align="center"
  //                     width="170px"
  //                   >
  //                     <InfoButtonContextProvider
  //                       buttonLabel="Company Margin (%)"
  //                       heading="Company Margin:"
  //                       messages={[
  //                         "The company margin will be applied if there does not exist a margin at the material class or for an individual style."
  //                       ]}
  //                     />
  //                   </TableCell>
  //                   <TableCell
  //                     className="mnd__table-cell"
  //                     align="center"
  //                     width="170px"
  //                   >
  //                     <TextField
  //                       variant="filled"
  //                       name="companyMargin"
  //                       type="number"
  //                       label="Company Margin (%)"
  //                       placeholder="Company Margin"
  //                       value={marginRate}
  //                       onChange={handleUpdateCompanyMargin}
  //                       size="small"
  //                     />
  //                     <InfoButtonContextProvider
  //                       buttonLabel="Modification Details"
  //                       heading="Modification Details:"
  //                       messages={renderChangeInfo(margin)}
  //                     />
  //                   </TableCell>
  //                   <TableCell
  //                     className="mnd__table-cell"
  //                     align="center"
  //                     width="170px"
  //                   >
  //                     <Button
  //                       className="admin__tax-update-btn"
  //                       variant="contained"
  //                       onClick={handleCompanyMarginSubmit}
  //                     >
  //                       Update
  //                     </Button>
  //                   </TableCell>
  //                 </TableRow>
  //               </TableBody>
  //             </Table>
  //           </TableContainer>
  //         </form>
  //         {/* </CardContent>
  //         </Card> */}
  //       </div>
  //     );
  //   } else {
  //     return <div>Loading...</div>;
  //   }
  // };

  const renderLoadedMargins = (data) => {
    if (data.length) {
      return (
        <div>
          <div className="mnd__header">
            <Typography className="mnd__header-text" variant="h4">
              Loaded Margin
            </Typography>
          </div>
          <Grid container spacing={3} style={{ marginTop: 30 }}>
            <Grid item xs={7} lg={8} style={{ paddingLeft: 40 }}>
              <TextField
                className="mnd__textfield"
                variant="filled"
                name="companyMargin"
                type="number"
                label={
                  <Typography variant="headline" component="small">
                    Loaded margin
                  </Typography>
                }
                placeholder="Default Margin"
                value={loadedMarginRate}
                onChange={handleUpdateLoadedMargin}
                size="small"
              />
              <InfoButtonContextProvider
                buttonLabel="Modification Details"
                heading="Modification Details:"
                messages={renderChangeInfo(loadedMargin)}
              />
            </Grid>
            <Grid
              item
              xs={5}
              lg={4}
              style={{ display: 'flex', alignContent: 'Bottom' }}
            >
              <Button
                style={{ height: 45, color: '#FF682C', marginRight: 10 }}
                // className="admin__tax-update-btn"
                variant="contained"
                onClick={handleLoadedMarginSubmit}
              >
                Update
              </Button>
            </Grid>
            {/* <Grid item xs={12} style={{marginTop:50}}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
              >
                <Typography variant="h5">Loaded Margin (%)</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                The Loaded Margin will be applied after Tax Rate. 
                The cost shown throughout the application is a loaded cost. 
                If you wish to not use a loaded cost set the loaded margin to 0 (zero).
                </Typography>
              </AccordionDetails>
            </Accordion>
            </Grid> */}
          </Grid>
        </div>
      );
    } else {
      <div>Loading...</div>;
    }
  };

  const renderCompanyMargins = (data) => {
    if (data.length) {
      return (
        <div>
          <div className="mnd__header">
            <Typography className="mnd__header-text" variant="h4">
              Company Margin
            </Typography>
          </div>
          <Grid container spacing={3} style={{ marginTop: 30 }}>
            <Grid item xs={7} lg={8} style={{ paddingLeft: 40 }}>
              <TextField
                className="mnd__textfield"
                variant="filled"
                name="companyMargin"
                type="number"
                label={
                  <Typography variant="headline" component="small">
                    Company margin
                  </Typography>
                }
                placeholder="Default Margin"
                value={marginRate}
                onChange={handleUpdateCompanyMargin}
                size="small"
              />
              <InfoButtonContextProvider
                buttonLabel="Modification Details"
                heading="Modification Details:"
                messages={renderChangeInfo(margin)}
              />
            </Grid>
            <Grid
              item
              xs={5}
              lg={4}
              style={{ display: 'flex', alignContent: 'Bottom' }}
            >
              <Button
                style={{ height: 45, color: '#FF682C', marginRight: 10 }}
                // className="admin__tax-update-btn"
                variant="contained"
                onClick={handleCompanyMarginSubmit}
              >
                Update
              </Button>
            </Grid>
            {/* <Grid item xs={12} style={{marginTop:50}}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
              >
                <Typography variant="h5">Company Margin (%)</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                The company margin will be applied if there does not exist a margin at the material class or for an individual style.

                </Typography>
              </AccordionDetails>
            </Accordion>
            </Grid> */}
          </Grid>
        </div>
      );
    } else {
      <div>Loading...</div>;
    }
  };

  // const renderLoadedMarginDetails = data => {
  //   // return data.length ? <div> Tax Data </div> : <div>Loading...</div>;
  //   if (data.length) {
  //     return (
  //       <div>
  //         {/* <Card><paper
  //           <CardContent> */}
  //         <form onSubmit={handleLoadedMarginSubmit}>
  //           <TableContainer className="cost-adjustment-paper">
  //             <div className="mnd__header">
  //             <Typography
  //               className="mnd__header-text"
  //               variant="h4">
  //               Loaded Margin
  //             </Typography>
  //             </div>

  //             <Table className="class-margin-details" aria-label="simple table">
  //               <TableHead>
  //                 <TableRow className="mnd__table-row">
  //                   {/* <TableCell><InfoButtonContextProvider buttonLabel="How is this applied?" heading="Company Margin:" messages={["Company wide default margin"]}/></TableCell> */}
  //                 </TableRow>
  //               </TableHead>
  //               <TableBody>
  //                 <TableRow className="mnd__table-row">
  //                   <TableCell
  //                     className="mnd__table-cell"
  //                     align="center"
  //                     width="170px"
  //                   >
  //                     <InfoButtonContextProvider
  //                       buttonLabel="Loaded Margin (%)"
  //                       heading="Loaded Margin:"
  //                       messages={[
  //                         "The Loaded Margin will be applied after Tax Rate. The cost shown throughout the application is a loaded cost. If you wish to not use a loaded cost set the loaded margin to 0 (zero)."
  //                       ]}
  //                     />
  //                   </TableCell>
  //                   <TableCell
  //                     className="mnd__table-cell"
  //                     align="center"
  //                     width="130px"
  //                   >
  //                     <TextField
  //                       variant="filled"
  //                       name="companyMargin"
  //                       type="number"
  //                       label="Loaded Margin (%)"
  //                       placeholder="Default Margin"
  //                       value={loadedMarginRate}
  //                       onChange={handleUpdateLoadedMargin}
  //                       size="small"
  //                     />
  //                      <InfoButtonContextProvider
  //                       buttonLabel="Modification Details"
  //                       heading="Modification Details:"
  //                       messages={renderChangeInfo(margin)}
  //                     />
  //                   </TableCell>
  //                   {/* <TableCell
  //                     className="mnd__table-cell"
  //                     align="center"
  //                     width="10px"
  //                   >
  //                     <InfoButtonContextProvider
  //                       buttonLabel="Modification Details"
  //                       heading="Modification Details:"
  //                       messages={renderChangeInfo(margin)}
  //                     />
  //                   </TableCell> */}
  //                   <TableCell
  //                     className="mnd__table-cell"
  //                     align="center"
  //                     width="170px"
  //                   >
  //                     <Button
  //                       className="admin__tax-update-btn"
  //                       variant="contained"
  //                       onClick={handleLoadedMarginSubmit}
  //                     >
  //                       Update
  //                     </Button>
  //                   </TableCell>
  //                 </TableRow>
  //               </TableBody>
  //             </Table>
  //           </TableContainer>
  //         </form>
  //         {/* </CardContent>
  //         </Card> */}
  //       </div>
  //     );
  //   } else {
  //     return <div>Loading...</div>;
  //   }
  // };

  const renderMarginSelect = () => {
    return (
      <div>
        <div className="mnd__header">
          <Typography className="mnd__header-text" variant="h4">
            Material Class Margins
          </Typography>
        </div>
        <Grid container spacing={3} style={{ marginTop: 30 }}>
          <Grid item xs={12} sm={6} md={4} lg={8} style={{ paddingLeft: 40 }}>
            <NativeSelect
              // className="admin__margin-role-select"
              style={{ width: '100%' }}
              onChange={handleRoleSelect}
              defaultValue={'Select Role'}
            >
              <option disabled>Select Role</option>
              {roles.map((r) => {
                return (
                  <option key={r.role_id} value={JSON.stringify(r)}>
                    {r.role_name}
                  </option>
                );
              })}
            </NativeSelect>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={2}
            style={{ display: 'flex', alignContent: 'Bottom' }}
          >
            <InfoButtonContextProvider
              style={{ float: 'left' }}
              buttonLabel="Modification Details"
              heading="Modification Details:"
              messages={renderChangeInfo(margin)}
            />
          </Grid>
        </Grid>
      </div>
    );
  };

  // Header definition: a visible label, help text, and a target column width.
  const MARGIN_COLUMNS = [
    {
      label: 'Material Class',
      width: '12%',
      heading: 'Material Class:',
      messages: [
        'The material class is a general type of material to categorize a product. Margins can be set at this level. If there are no margins set for individual Style this will be used.',
        'Additional costs such as installation, padding, hardware, etc. can be added using the "Added costs $" field.',
      ],
    },
    {
      label: 'Pre-margin Added $ / UOM',
      width: '14%',
      heading: 'Pre-margin Added Costs / UOM:',
      messages: [
        'This is used to add a dollar amount to the final cost based on the selling unit of measure before the margin has been applied.',
        'For example: adding $1.25 for carpet will add $1.25 per square foot to the total price. This is typically used to cover pad and install OR freight.',
        'This is the "Pre-margin Added $" step in How Your Prices Are Calculated.',
      ],
    },
    {
      label: 'Loaded Margin %',
      width: '10%',
      heading: 'Material Class Loaded Margin:',
      messages: [
        'Loaded margin for this material class and role, applied when building the loaded cost your team sees. When set, it is used instead of the company-wide Loaded Margin (%).',
        'This is the "Loaded Margin" step in How Your Prices Are Calculated.',
      ],
    },
    {
      label: 'Loaded Markup %',
      width: '10%',
      heading: 'Material Class Loaded Markup:',
      messages: [
        'Markup applied to the converted cost for this material class when building the loaded cost (cost × (1 + markup)). Applied in addition to the loaded margin.',
        'This is the "Loaded Markup" step in How Your Prices Are Calculated.',
      ],
    },
    {
      label: 'Margin %',
      width: '10%',
      heading: 'Material Class Margin:',
      messages: [
        'This is the margin to be applied based on the material class code and selected role. If no margin is set it will default to the Company Margin (%).',
        'This is the "Margin" step in How Your Prices Are Calculated — a per-style override or a cost adjustment rule\'s Margin % beats it, and the Company Margin (%) is the fallback.',
      ],
    },
    {
      label: 'Post-margin Added $ / UOM',
      width: '14%',
      heading: 'Post-margin Added Costs / UOM:',
      messages: [
        'This is used to add a dollar amount to the final retail price based on the selling unit of measure after the margin has been applied.',
        'For example: adding $1.25 for carpet will add $1.25 per square foot to the total price. This is typically used to cover pad and install OR freight.',
        'This is the "Post-margin Added $" step in How Your Prices Are Calculated.',
      ],
    },
    {
      label: 'Disclaimer',
      width: '24%',
      heading: 'Material Class Disclaimer:',
      messages: [
        'This is the disclaimer to be displayed on the product page for the material class and selected role.',
      ],
    },
    { label: '', width: '6%' }, // status column
  ];

  const renderClassMarginDetails = (data) => {
    const dirtyCount = getDirtyRows(data).length;
    return (
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        fullWidth
        maxWidth="xl"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ paddingBottom: 4 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
            <Typography variant="h5" style={{ fontWeight: 600 }}>
              Material Class Margins
            </Typography>
            <Typography variant="h6" style={{ color: '#FF682C' }}>
              {roleName}
            </Typography>
          </div>
          <Typography variant="body2" color="textSecondary">
            Edit any material classes below, then click <b>Save Changes</b> once — no need to save each row.
          </Typography>
        </DialogTitle>
        <DialogContent dividers style={{ padding: 0 }}>
          <TableContainer style={{ maxHeight: '62vh' }}>
            <Table className="class-margin-details" stickyHeader size="small" aria-label="material class margins">
              <TableHead>
                <TableRow>
                  {MARGIN_COLUMNS.map((col, idx) =>
                    col.messages ? (
                      <Tooltip key={idx} title={col.messages.join(' ')} arrow>
                        <TableCell
                          className="mnd__table-cell"
                          component="th"
                          scope="col"
                          align="center"
                          style={{ backgroundColor: '#fafafa', fontWeight: 600, whiteSpace: 'nowrap', cursor: 'help', textDecoration: 'underline dotted' }}
                        >
                          {col.label}
                        </TableCell>
                      </Tooltip>
                    ) : (
                      <TableCell
                        key={idx}
                        className="mnd__table-cell"
                        component="th"
                        scope="col"
                        align="center"
                        style={{ backgroundColor: '#fafafa' }}
                      />
                    )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row, i) => {
                  const mc = row.material_class;
                  const dirty = isRowDirty(mc);
                  return (
                    <TableRow
                      className="mnd__table-row"
                      key={mc + i}
                      style={dirty ? { backgroundColor: '#fff6ef' } : undefined}
                    >
                      <TableCell
                        className="mnd__table-cell"
                        component="th"
                        scope="row"
                        align="center"
                        style={{ fontWeight: 600, borderLeft: dirty ? '3px solid #FF682C' : '3px solid transparent' }}
                      >
                        {mc || undefined}
                      </TableCell>
                      <TableCell className="mnd__table-cell">
                        <TextField
                          variant="outlined"
                          name="premarginaddedcosts"
                          type="number"
                          placeholder="0.00"
                          fullWidth
                          value={addToCost[mc] ?? ''}
                          onChange={(e) => handleUpdateAddToCost(e, mc)}
                          size="small"
                          InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                        />
                      </TableCell>
                      <TableCell className="mnd__table-cell">
                        <TextField
                          variant="outlined"
                          name="loadedmarginbyclass"
                          type="number"
                          placeholder={`${loadedMarginRate} (default)`}
                          fullWidth
                          value={loadedMarginByClass[mc] === null ? '' : loadedMarginByClass[mc] ?? ''}
                          onChange={(e) => handleUpdateLoadedMarginByClass(e, mc)}
                          size="small"
                          InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
                        />
                      </TableCell>
                      <TableCell className="mnd__table-cell">
                        <TextField
                          variant="outlined"
                          name="loadedmarkupbyclass"
                          type="number"
                          placeholder="0"
                          fullWidth
                          value={loadedMarkupByClass[mc] === null ? '' : loadedMarkupByClass[mc] ?? ''}
                          onChange={(e) => handleUpdateLoadedMarkupByClass(e, mc)}
                          size="small"
                          InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
                        />
                      </TableCell>
                      <TableCell className="mnd__table-cell">
                        <TextField
                          variant="outlined"
                          name="companyMargin"
                          type="number"
                          placeholder={`${marginRate} (default)`}
                          fullWidth
                          value={materialMarginRate[mc] === null ? '' : materialMarginRate[mc] ?? ''}
                          onChange={(e) => handleUpdateMaterialMargin(e, mc)}
                          size="small"
                          InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
                        />
                      </TableCell>
                      <TableCell className="mnd__table-cell">
                        <TextField
                          variant="outlined"
                          name="postmarginaddedcosts"
                          type="number"
                          placeholder="0.00"
                          fullWidth
                          value={addToPrice[mc] ?? ''}
                          onChange={(e) => handleUpdateAddToPrice(e, mc)}
                          size="small"
                          InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                        />
                      </TableCell>
                      <TableCell className="mnd__table-cell">
                        <TextField
                          variant="outlined"
                          name="productdisclaimer"
                          multiline
                          rows={2}
                          placeholder="Disclaimer…"
                          fullWidth
                          value={productDisclaimer[mc] ?? ''}
                          onChange={(e) => handleUpdateProductDisclaimer(e, mc)}
                          size="small"
                        />
                      </TableCell>
                      <TableCell className="mnd__table-cell" align="center" style={{ whiteSpace: 'nowrap' }}>
                        {dirty && (
                          <Typography
                            variant="caption"
                            style={{ color: '#FF682C', fontWeight: 600, display: 'block' }}
                          >
                            Unsaved
                          </Typography>
                        )}
                        <InfoButtonContextProvider
                          buttonLabel="Modification Details"
                          heading="Modification Details:"
                          messages={[
                            row.user_name ? `Last Modified By: ${row.user_name}` : 'Last Modified By: —',
                            row.name ? `Last Modified User: ${row.name}` : 'Last Modified User: —',
                            row.last_modified_dttm ? `Last Modified: ${formatDttm(row.last_modified_dttm)}` : 'Last Modified: —',
                          ]}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'space-between', padding: '12px 24px' }}>
          <Typography variant="body2" color="textSecondary">
            {dirtyCount > 0
              ? `${dirtyCount} unsaved change${dirtyCount > 1 ? 's' : ''}`
              : 'All changes saved'}
          </Typography>
          <div>
            <Button onClick={handleDialogClose} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              className="admin__tax-update-btn"
              onClick={() => handleSaveAll(data)}
              disabled={dirtyCount === 0 || savingAll}
              startIcon={savingAll ? <CircularProgress size={16} color="inherit" /> : null}
            >
              {savingAll ? 'Saving…' : `Save Changes${dirtyCount ? ` (${dirtyCount})` : ''}`}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <div>
      <Box sx={{ flexGrow: 1 }}>
        {/* Only renders for customers on the custom calc graph. */}
        <CalculationSummary />
        <CostAdjustmentRules />
        <FreightRates />
        <Grid container style={{ display: 'flex', alignContent: 'center' }}>
          <Grid item xs={12} sm={12} md={6} lg={3} className="grid-item">
            <Paper elevation={5} className="mnd__box-paper">
              <TaxUpdate />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={3} className="grid-item">
            <Paper elevation={5} className="mnd__box-paper">
              {renderLoadedMargins(margin)}
              <Accordion style={{ marginTop: 75 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6">Loaded Margin (%)</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    The Loaded Margin will be applied after Tax Rate. The cost
                    shown throughout the application is a loaded cost. If you
                    wish to not use a loaded cost set the loaded margin to 0
                    (zero).
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={3} className="grid-item">
            <Paper elevation={5} className="mnd__box-paper">
              {renderCompanyMargins(margin)}
              <Accordion style={{ marginTop: 75 }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                >
                  <Typography variant="h6">Company Margin (%)</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    The company margin will be applied if there does not exist a
                    margin at the material class or for an individual style.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={3} className="grid-item">
            <Paper elevation={5} className="mnd__box-paper">
              <SalesTax />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={3} className="grid-item">
            <Paper elevation={5}>{renderRetailRoundup()}</Paper>
          </Grid>
          {roles.length ? (
            <Grid item xs={12} sm={12} md={6} lg={3} className="grid-item">
              <Paper elevation={2} className="mnd__mat-margin-sel">
                {renderMarginSelect()}
                <Accordion style={{ marginTop: 75 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                  >
                    <Typography variant="h6">Material Class</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      "The material class is a general type of material to
                      categorize a product. Margins can be set at this level. If
                      there are no margins set for individual Style this will be
                      used.", 'Additional costs such as installation, padding,
                      hardware, etc. can be added using the "Added costs $"
                      field.'
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Paper>

              <Paper elevation={2} className="mnd__mat-margin-sel">
                {renderClassMarginDetails(materialClassMargins)}
              </Paper>
            </Grid>
          ) : (
            ''
          )}
          <Grid item xs={12} sm={12} md={4} lg={3} className="grid-item">
            <Paper
              elevation={5}
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin: 'auto',
              }}
            >
              {renderUsePromoPrice()}
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={3} className="grid-item">
            <Paper elevation={5} className="mnd__box-paper" style={{ display: 'flex', flexDirection: 'column' }}>
              <UnitConversions />
            </Paper>
          </Grid>
        </Grid>
      </Box>
      {/* <Card>
            <CardContent> */}
      {/* <Paper className="admin__tax-header">
        <Typography
          className="admin__tax-mnd__header-text"
          variant="h5"
          align="center"
        >
          Company Margin
        </Typography>
      </Paper> */}

      {/* <h1 align="center" className="admin__tax-content-label">
        {<AttachMoneySharpIcon />} Tax Adjustment
      </h1> */}

      {/* <Paper elevation={2} className="mnd__mat-margin-sel">
          <TaxUpdate/>
        </Paper> */}

      {/* <h1 align="center" className="admin__tax-content-label">
        {<AttachMoneySharpIcon />} Margin Adjustment
      </h1> */}

      {/* <Paper elevation={2} className="mnd__mat-margin-sel">
        {renderLoadedMarginDetails(margin)}
      </Paper> */}

      {/* <Paper elevation={2} className="mnd__mat-margin-sel">
        {renderCompanyMarginDetails(margin)}
      </Paper> */}

      {/* <Paper elevation={2} className="mnd__mat-margin-sel">
        <SalesTax/>
      </Paper> */}

      {/* </CardContent>
      </Card> */}
    </div>
  );
};

export default CompanyMarginUpdate;
